// extracted by mini-css-extract-plugin
export default {"rowResultado":"importacao_rowResultado__O3U4W"};